<script setup>
const route = useRoute()
const areaCategory = getAreaCategory(route.params.area)
const { data: cityConfig } = await useFetch('/api/kosa/cityCode', { query: { citycode: route.params.city } })
if (areaCategory !== 'pref' || !cityConfig.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Path'
  })
}
useCustomMeta('city', cityConfig.value.name, getFullPrefectureName(route.params.area))
const breadCrumbList = getBreadCrumb(route.params.area, areaCategory, cityConfig.value.name)
const { data: mapPosition } = await useFetch('/api/kosa/mapConfig', { query: { path: route.params.city } })
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :pref="getAreaPrefectureName(route.params.area)"
      :pref-roma="route.params.area"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <KosaMap
          :map-position="mapPosition"
          :title="cityConfig.name"
          :pref-en="route.params.area"
          :city-code="route.params.city"
        />
      </div>
      <template #main-bottom>
        <KosaCityList :pref="route.params.area" />
        <KosaPrefList
          v-if="route.params.area!=='okinawa'"
          :area="getAreaByPrefKey(route.params.area).key"
        />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.satellite {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .slider {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    .content {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding-top: 20px;
  }
  .box {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 10px;
    background-color: #eef1f8;
  }
}
.main {
  .satellite {
    @media screen and (min-width: 830px) {
      .box {
        padding-inline: 15px;
      }
    }
  }
}
</style>
